
import { useQuery } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Product, Guid } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useDefaultProductQuery(guid: Guid | undefined) {
    const api = useApi();

    return useQuery(QueryKeys.Product(guid), ({ queryKey }) => {
        const [_, dealGuid] = queryKey;

        return AxiosUtils.getResponseData<Product>(api.get(CerebroApiEndpoints.DefaultProduct(dealGuid)));
    });
}
